module.exports = __webpack_public_path__ + "assets/img/ty8.11f3a80b.jpg";